import { useEffect, useMemo, useState } from 'react';
import { FaHeadphones, FaPhoneAlt, FaShip, FaTimes } from 'react-icons/fa';
import { CRUISE_PHONE_DISPLAY, CRUISE_PHONE_TEL } from '../../constants/contact';
import { SITE_DOMAIN, SITE_NAME, SITE_TAGLINE } from '../../constants/site';
import './CruiseMobileSupportPopup.css';

const CRUISE_SUPPORT_ITEMS = [
  'Cruise Booking',
  'Manage Sailing',
  'Cancellation',
  'Guest Services',
];

const POPUP_STORAGE_KEY = 'fastfares_cruise_mobile_support_popup_dismissed';

export default function CruiseMobileSupportPopup() {
  const [isOpen, setIsOpen] = useState(false);

  const telHref = useMemo(() => `tel:${CRUISE_PHONE_TEL}`, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const isDismissed = window.sessionStorage.getItem(POPUP_STORAGE_KEY) === '1';

    if (isDismissed) {
      return undefined;
    }

    const timeout = window.setTimeout(() => {
      setIsOpen(true);
    }, 700);

    return () => window.clearTimeout(timeout);
  }, []);

  const closePopup = () => {
    setIsOpen(false);
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(POPUP_STORAGE_KEY, '1');
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="cruise-mobile-popup__backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Cruise support popup"
    >
      <div className="cruise-mobile-popup">
        <button
          type="button"
          className="cruise-mobile-popup__close"
          onClick={closePopup}
          aria-label="Close popup"
        >
          <FaTimes aria-hidden />
        </button>

        <p className="cruise-mobile-popup__brand">{SITE_NAME}</p>
        <p className="cruise-mobile-popup__domain">{SITE_DOMAIN}</p>
        <h2 className="cruise-mobile-popup__title">Cruise Reservations</h2>
        <p className="cruise-mobile-popup__subtitle">Click to Call Our Cruise Expert</p>

        <a href={telHref} className="cruise-mobile-popup__phone-link">
          <FaPhoneAlt aria-hidden />
          <span>{CRUISE_PHONE_DISPLAY}</span>
        </a>
        <p className="cruise-mobile-popup__support-text">24/7 Cruise Booking Support</p>

        <div className="cruise-mobile-popup__grid" role="list" aria-label="Cruise support categories">
          {CRUISE_SUPPORT_ITEMS.map((item) => (
            <span key={item} className="cruise-mobile-popup__grid-item" role="listitem">
              {item}
            </span>
          ))}
        </div>

        <div className="cruise-mobile-popup__media" aria-hidden>
          <FaShip size={58} />
          <span className="cruise-mobile-popup__avatar">
            <FaHeadphones size={34} />
          </span>
        </div>

        <p className="cruise-mobile-popup__tagline">{SITE_TAGLINE}</p>

        <a href={telHref} className="cruise-mobile-popup__offer">
          <span className="cruise-mobile-popup__offer-icon">
            <FaPhoneAlt aria-hidden />
          </span>
          <span className="cruise-mobile-popup__offer-copy">
            <small>Phone-Only Cruise Deals</small>
            <strong>{CRUISE_PHONE_DISPLAY}</strong>
          </span>
        </a>
      </div>
    </div>
  );
}
